var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternal1List(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Internal_1_List"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Internal_1_List",
    "data-name": "Internal 1_List",
    clipPath: "url(#clip-Internal_1_List)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_658",
    "data-name": "Ellipse 658",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(1 1)",
    fill: "#0071cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4562",
    "data-name": "Path 4562",
    d: "M0,1003.32l3.74,0a3.324,3.324,0,0,1,1.282.234,1.908,1.908,0,0,1,1.276,1.65,1.965,1.965,0,0,1-.924,2.008.526.526,0,0,0-.055.047.876.876,0,0,0,.088.047,1.844,1.844,0,0,1,1.219,1.7,2.275,2.275,0,0,1-2.239,2.577c-.95.08-1.911.037-2.867.047a.4.4,0,0,1-.08-.013.583.583,0,0,1-.528-.529,2.03,2.03,0,0,1-.023-.361q0-2.918,0-5.836v-.285H0Zm2.43,4.654v2.1a.247.247,0,0,0,.279.271c.41,0,.821.01,1.231,0a1.077,1.077,0,0,0,1.1-.976,1.113,1.113,0,0,0-.861-1.379,16.265,16.265,0,0,0-1.751-.013m.011-3.368v2.1c.507,0,1.006.03,1.5-.009a.933.933,0,0,0,.808-.981.9.9,0,0,0-.7-1.037c-.527-.073-1.068-.053-1.612-.074",
    transform: "translate(6.183 -997.979)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternal1List);
export default __webpack_public_path__ + "static/media/Internal 1_List.7a8b6af3ac06193cf4f1a5d454141b5f.svg";
export { ForwardRef as ReactComponent };